import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import MainPage from "./pages/MainPage";
import TestCasePage from "./pages/TestCasePage";
import ProtectedRoute from "./components/ProtectedRoute";
import ServicesStatusHistoryPage from "./pages/ServicesStatusHistoryPage";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <MainPage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/testcase"
                    element={
                        <ProtectedRoute>
                            <TestCasePage />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/services-history"
                    element={
                        <ProtectedRoute>
                            <ServicesStatusHistoryPage />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
